var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "answer-item__con align-stretch"
  }, [_c('div', {
    staticClass: "answer-item__textarea"
  }, [_c('v-textarea', {
    attrs: {
      "outlined": ""
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1), _c('div', {
    staticClass: "answer-item__btn-wrap"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary",
      "height": "100%"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("등록")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }